module.exports = __webpack_public_path__ + "stockholm-9057ae3a531d09d167332be0834e4a59.bundle.jpg";